module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/ja/5-dfb595e32aa6041a0b227ac69fb5520a.jpg";